import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LayoutShellComponent } from './layout/layout-shell.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmployeesComponent } from './employees/employees.component';
import { CoursesComponent } from './courses/courses.component';
import { StaticScreenComponent } from './layout/static-screen.component';
import { TeamComponent } from './team/team.component';
import { authoriseGuard } from './shared/guards/authorise.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutShellComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'screen/DASHBOARD' },
      { path: 'screen/DASHBOARD', component: DashboardComponent, canActivate: [authoriseGuard], data: { screenKey: 'DASHBOARD' } },
      { path: 'screen/EMPLOYEES', component: EmployeesComponent, canActivate: [authoriseGuard], data: { screenKey: 'EMPLOYEES' } },
      { path: 'screen/COURSES', component: CoursesComponent, canActivate: [authoriseGuard], data: { screenKey: 'COURSES' } },
      { path: 'screen/TEAM', component: TeamComponent, canActivate: [authoriseGuard], data: { screenKey: 'TEAM' } },
      { path: 'screen/MYTEAM', component: TeamComponent, canActivate: [authoriseGuard], data: { screenKey: 'MYTEAM' } },
      { path: 'screen/:name', component: StaticScreenComponent, canActivate: [authoriseGuard] },
      { path: '**', redirectTo: 'screen/DASHBOARD' }
    ]
  }
];
